"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CultureProvider = void 0;
const all_cultures_1 = require("../im-cultures/all-cultures");
class CultureProvider {
    static getCultureByLocaleCurrency(locale, currency) {
        if (locale)
            locale = locale.toLowerCase();
        if (currency)
            currency = currency.toLocaleUpperCase();
        let currencyCultures = all_cultures_1.AllCultures[locale];
        if (currencyCultures) {
            let culture;
            if (currency) {
                culture = currencyCultures[currency];
            }
            else {
                culture = currencyCultures[Object.keys(currencyCultures)[0]];
            }
            if (culture) {
                return culture;
            }
        }
        throw new Error(`Unknown locale/currency combination ${locale}/${currency}`);
    }
    static getAllCurrenciesByLocale(locale) {
        if (locale)
            locale = locale.toLowerCase();
        let currencyCultures = all_cultures_1.AllCultures[locale];
        if (currencyCultures) {
            return Object.keys(currencyCultures);
        }
        throw new Error(`Unknown locale ${locale}`);
    }
}
exports.CultureProvider = CultureProvider;
